/*globals VXConfig*/
import PropTypes from 'prop-types';
import VXButton from '../SimpleElements/VXButton/VXButton';
import { COLOR_TYPE_CALL_TO_ACTION } from '../SimpleElements/VXButton/ButtonHelper';
import { VXButtonLineConfig, VXButtonLineStyle } from '../SimpleElements/VXButton/VXButtonConfig';
import STYLES from '../SimpleElements/VXButton/EnumVXButton';
import ActorAvatar from '../ActorAvatar';
import Flux from '../../flux/Flux';
import Translations from '../../utils/Translations';
import UrlBuilder from '../../utils/UrlBuilder';
import ReloadHelper from '../../utils/ReloadHelper';
import { Component } from 'react';

export default class PrivateTicketShowInvitationBox extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="private-ticket-show-invitation-box">
				<i className="icon -icon-close-line private-ticket-show-invitation-box_exit" onClick={this.props.onClose} />
				<div className={'private-ticket-show-invitation-box_wrapper'}>
					<span className={'private-ticket-show-invitation-box_avatar'}>
						<ActorAvatar
							actorUrl={UrlBuilder.buildActorProfileUrl(this.props.actorName)}
							isOnline={true}
							actorUrlPreviewPicture={this.props.actorProfilePictureUrl}
							size={60}
							onClickFn={(e) => {
								ReloadHelper.reload(UrlBuilder.buildActorProfileUrl(this.props.actorName), e);
								this.props.onClose();
							}}
						/>
					</span>
					<div className={'private-ticket-show-invitation-box_text'}>
						<div>{Translations.get('messenger.private_ticket_show_invitation_text1', VXConfig.guestName)}</div>
						<div>{Translations.get('messenger.private_ticket_show_invitation_text2', this.props.actorName)}</div>
					</div>
				</div>
				<div className={'private-ticket-show-invitation-box_button'}>
					<VXButton
						line1={[new VXButtonLineConfig('Zur Einladung', new VXButtonLineStyle([STYLES.LIGHT]))]}
						color={COLOR_TYPE_CALL_TO_ACTION}
						size={STYLES.SIZE.TINY}
						onClick={() => {
							Flux.Messenger.selectChannelByActorId(this.props.actorId);
							this.props.onClose();
						}}
					/>
				</div>
			</div>
		);
	}
}

PrivateTicketShowInvitationBox.propTypes = {
	actorName: PropTypes.string.isRequired,
	actorId: PropTypes.number.isRequired,
	actorProfilePictureUrl: PropTypes.string.isRequired,
	onClose: PropTypes.func.isRequired,
};
